import { useMutation } from '@tanstack/react-query';
import Notify from '@/components/Notification';
import { userService } from '../../services/userService';
import { markRefreshSessionHint } from '@/helpers/authSession';
import { useUserStore } from '@/store/userStore';

export const useRegisterUser = () => {
  return useMutation({
    mutationFn: payload =>
      userService.registerUser(payload).then(response => {
        const { status, data } = response;

        if (status === 200 || status === 201) {
          markRefreshSessionHint();
          useUserStore.getState().setAccessToken(data.access_token);
          Notify.success({ text: 'Account created' });
          return { data, success: true };
        }

        if (status === 406) {
          return { status, data, success: false };
        }

        return null;
      }),
  });
};
